import type { ThemeTokens, ThemeRecord } from './types';

export function adaptThemeTokens(raw: unknown): ThemeTokens {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<ThemeTokens>;
  return {
    primary: String(data.primary || '222 47% 24%'),
    background: String(data.background || '0 0% 100%'),
    foreground: String(data.foreground || '222 47% 11%'),
    accent: String(data.accent || '354 71% 48%'),
    headingFont: String(data.headingFont || 'Playfair Display'),
    bodyFont: String(data.bodyFont || 'Inter'),
    darkMode: Boolean(data.darkMode),
  };
}

export function adaptThemeRecord(raw: unknown): ThemeRecord {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<ThemeRecord>;
  return {
    id: String(data.id || ''),
    tenant_id: String(data.tenant_id || ''),
    site_id: String(data.site_id || ''),
    name: String(data.name || 'Default Theme'),
    tokens_json: typeof data.tokens_json === 'string'
      ? (() => { try { return JSON.parse(data.tokens_json as string); } catch { return {}; } })()
      : (data.tokens_json && typeof data.tokens_json === 'object' ? data.tokens_json : {}),
    heading_font: String(data.heading_font || 'Playfair Display'),
    body_font: String(data.body_font || 'Inter'),
    dark_mode_enabled: Boolean(data.dark_mode_enabled),
    created_at: String(data.created_at || ''),
    updated_at: String(data.updated_at || ''),
  };
}

export function adaptThemeRecordList(raw: unknown): ThemeRecord[] {
  if (!Array.isArray(raw)) return [];
  return raw.map(adaptThemeRecord);
}
